// extracted by mini-css-extract-plugin
module.exports = {"maskIcon":"_18F2fXG","lightIcon":"JszDwye _18F2fXG","darkIcon":"_2fHbZbZ _18F2fXG","blackIcon":"_1UjnxzS _18F2fXG","alert":"_3SyTomz","success":"_2ZaqKbU","error":"_1ktc_KH"};